import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

export const instance = axios.create({
  baseURL: '/',
  timeoutErrorMessage: "Время ожидания запроса истекло. Попробуйте ещё раз или обратитесь в поддержку."

});

const userJson = localStorage.getItem("user");
if (userJson) {
  const user = JSON.parse(userJson as string);
  instance.defaults.headers.common["Authorization"] = `Bearer ${user.token}`;
}

//настройки axios клиента для строгой проверки десерриализации json
//в случае ошибок будем получать ERR_BAD_RESPONSE и показывать пользователю
//в общем случае ошибок быть не должно так как мы возвращаем собственные ответы, но в случае ошибок сереализация на бэке
//мы об этом узнаем
const strictJsonValidationParsingSettings = {
  responseType: "json",
  transitional: {
    silentJSONParsing: false, //в случае невалидного json axios вернёт строку вместо объекта, это помогает получить ошибку в райнтайме
    forcedJSONParsing: true
  }
} as AxiosRequestConfig<any>;

instance.interceptors.response.use((response) => { return response; }, (error: AxiosError) => {
  //input valudation error
  const status = error.response?.status;
  switch (status) {
    case 404:
      alert("Путь не найден");
      break;
    case 401:
      window.location.href = "/";
      break;
    case 400:
      let message = '';
      const data = error.response?.data as any;
      for (let property in data.errors) {
        data.errors[property].forEach((entry: string): void => {
          if (entry) {
            message += entry + '\n';
          }
        })
      }
      alert(message);
      break;
    default:
      if (error.code) {
        if (error.code === "ERR_BAD_RESPONSE") {
          alert("Ошибка данных поставщика ERR_BAD_RESPONSE. StackTrace: " + error.stack);
        }
        if (error.code === "ECONNABORTED") {
          alert("Время ожидания истекло, сервер не ответил. ");
        }
      }
      //alert("Возникла ошибка. " + error.response?.data)
      break;
  }
  return Promise.reject(error);
});



export const signUp = (email: string) => {
  return instance.post('/api/account/register', { email });
}

export const login = (email: string, password: string, signInId: string | null) => {
  return instance.post('/api/account/login', { email, password, signInId })
}

export const forgot = (email: string) => {
  return instance.post('/api/account/forgot', { email })
}

export const listUsers = () => {
  return instance.get("/api/admin/users", {
    transitional: {

    }
  });
}

export const blockUser = (accountId: string) => {
  return instance.post("/api/admin/users/block", { accountId });
}

export const unblockUser = (accountId: string) => {
  return instance.post("/api/admin/users/unblock", { accountId });
}

export const deleteUser = (accountId: string) => {
  return instance.post("/api/admin/users/delete", { accountId });
}

export const listSuppliersTemplates = () => {
  return instance.get("/api/admin/suppliers/templates");
}
export const addGlobalSupplier = (data: any) => {
  return instance.post("/api/admin/suppliers/global/add", data);
}

export const listGlobalSuppliers = () => {
  return instance.get("/api/admin/suppliers/global/list");
}

export const getGlobalSupplier = (id: string) => {
  return instance.get("/api/admin/suppliers/global/get/" + id);
}

export const deleteGlobalSupplier = (id: string) => {
  return instance.delete("/api/admin/suppliers/global/delete/" + id);
}

export const globalSupplierSwitchProductSearch = (globalSupplierId: string, value: boolean) => {
  return instance.post(`/api/admin/suppliers/global/${globalSupplierId}/switchProductSearch`, { value });
}

export const globalSupplierSwitchArticleSearch = (globalSupplierId: string, value: boolean) => {
  return instance.post(`/api/admin/suppliers/global/${globalSupplierId}/switchArticleSearch`, { value });
}

export const globalSupplierEnabledSwitch = (globalSupplierId: string, value: boolean) => {
  return instance.post(`/api/admin/suppliers/global/${globalSupplierId}/enabled`, { value });
}

export const getAutoEuroDeliveries = (apiKey: string) => {
  return instance.get(`/api/SupplierCustom/AutoEuroPullDeliveries/${apiKey}`);
}

export const getRosskoDeliveries = (keyOne: string, keyTwo: string) => {
  return instance.get(`/api/supplierCustom/RosskoPullDeliveries?keyOne=${keyOne}&keyTwo=${keyTwo}`);
}

export async function getArmtekOrgInfo(login: string, password: string) {
  return await instance.get(`/api/supplierCustom/ArmtekOrgInfo?login=${login}&password=${password}`);
}

export const getArmtekAccountInfo = (login: string, password: string, organizationId: string) => {
  return instance.get(`/api/supplierCustom/getArmtekAccountInfo?login=${login}&password=${password}&organizationId=${organizationId}`);
}



export const getRequestHistory = async (requestId: string) => {
  const response = await instance.get(`api/results/suppliers/${requestId}`, strictJsonValidationParsingSettings);
  return response;
}

export const user = {
  getSuggestions(term: string) {
    const promise = instance.get(`api/brand/suggest?term=${term}`);
    return promise;

  },

  async me() {
    const response = await instance.get('/api/me');
    return response;
  },
  async requestSuppliers(data: any) {
    return await instance.post("/api/user/suppliers/request", data);
  },
  listAvailableSuppliers() {
    return instance.get("/api/user/suppliers/available/list");
  },
  listMySuppliers(accountId?: string) {
    let baseUrl = `/api/user/suppliers/my/list?`;
    if (accountId) {
      baseUrl += `accountId=${accountId}`
    }
    return instance.get(baseUrl);
  },

  addSupplier(connecteSupplierModel: any) {
    return instance.post("/api/user/suppliers/add", connecteSupplierModel);
  },

  async deleteSupplier(id: string) {
    return instance.post("/api/user/suppliers/delete/" + id);
  },

  testSupplierConnection(connecteSupplierModel: any, timeout: number) {
    return instance.post("/api/user/suppliers/testconnection", connecteSupplierModel, { timeout: timeout });
  },

  switchArticleSearch(userSupplierId: string, value: boolean) {
    return instance.post(`/api/user/suppliers/${userSupplierId}/switchArticleSearch`, { value });
  },

  switchGlobalArticleSearch(userSupplierId: string, value: boolean) {
    return instance.post(`/api/user/suppliers/${userSupplierId}/switchGlobalArticleSearch`, { value });
  },

  switchProductsSearch(userSupplierId: string, value: boolean) {
    return instance.post(`/api/user/suppliers/${userSupplierId}/switchProductsSearch`, { value });
  },

  async searchByArticle(article: string, brand: string, requestId: string, connectionId: string) {
    const response = await instance.post("/api/search/searchv2", {
      article,
      brand: brand,
      requestId: requestId,
      connectionId
    });
    return response;
  },

  async searchByArticleV2(article: string, brand: string, requestId: string) {
    const response = await instance.post("/api/search/searchv3", {
      vendorCode: article,
      brand: brand,
      requestId: requestId
    });
    return response;
  },

  async readSupplierResults(requestId: string, supplierId: string) {
    const response = await instance.get(`api/results/supplier/${requestId}/${supplierId}`, strictJsonValidationParsingSettings);
    return response;
  }
}

export const payments = {
  async getInfo() {
    return await instance.get("/api/payments/info");
  },

  async createOrder(order: any) {
    return await instance.post("/api/payments/createOrder", order);
  }
}

export const subscription = {
  async get(accountId?: string) {
    let baseUrl = "/api/subscription?";
    if (accountId) {
      baseUrl += `accountId=${accountId}`;
    }
    return await instance.get(baseUrl);
  },
  async updateUsersCount(subscriptionId: string, deviceCount: number) {
    let baseUrl = "/api/subscription/users/count";
    return await instance.put(baseUrl, {
      deviceCount: deviceCount,
      subscriptionId
    });
  },

  async getUserCountAudit(subscriptionId: string) {
    let baseUrl = "/api/subscription/users/count/audit?subscriptionId=" + subscriptionId;
    const response = await instance.get(baseUrl);
    return response.data as string[];
  },

  async fixPrice(subscriptionId: string, price: number) {
    let baseUrl = "/api/subscription/fixprice";
    return await instance.post(baseUrl, {
      price: price,
      subscriptionId
    });
  },

  async saveExpirationDate(subscriptionId: string, newExpirationDate: string) {
    let baseUrl = "/api/subscription/expirationDate";
    return await instance.post(baseUrl, {
      newExpirationDate: newExpirationDate,
      subscriptionId
    });
  },

  async clearFixPrice(subscriptionId: string) {
    let baseUrl = "/api/subscription/fixprice/clear";
    return await instance.post(baseUrl, {
      subscriptionId
    });
  }
}

export const admin = {
  userLogs: {
    async list(userId: string) {
      let baseUrl = "/api/userlogs/list/" + userId;
      return await instance.get(baseUrl);
    },

    download(url: string, filename: string) {
      axios.get(url, {
        responseType: 'blob',
      }).then((response: AxiosResponse) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', decodeURI(filename));
        document.body.appendChild(link);
        link.click();
      });
    }
  }
};

export const retailPriceApi = {
  settings: {
    async get() {
      const response = await instance.get("/api/RetailPriceSettings");

      return response.data;
    },

    async post(settings: any) {
      const response = await instance.post("/api/RetailPriceSettings", settings);

      return response.data;
    },

    async put(id: string, settings: any) {
      const response = await instance.put("/api/RetailPriceSettings?id=" + id, settings);

      return response.data;
    },

    async delete(id: string) {
      const response = await instance.delete("/api/RetailPriceSettings?id=" + id);

      return response.data;
    }
  },
  priceExample: {
    async get(percent: number) {
      const response = await instance.get("/api/RetailPriceExample?percent=" + percent);

      return response.data;
    }
  }
};

export const featuresApi = {
  features: {
    async get() {
      const response = instance.get("/api/features");
      return response;
    }
  }
}